'use client';

import {API} from '@/lib/utils/api.utils';
import {isBrowser} from '@/lib/utils/page.utils';
import {CspViolationPayload} from '@/types/error.types';
import {useEffect} from 'react';

const CSP_LOG_ENDPOINT = '/log/csp';

/**
 * Listens for CSP securitypolicyviolation events on the document and sends them to the logging API.
 */
export const useCspViolation = () => {
	useEffect(() => {
		if (!isBrowser()) return;

		const handler = (e: SecurityPolicyViolationEvent) => {
			const payload: CspViolationPayload = {
				violatedDirective: e.violatedDirective,
				blockedURI: e.blockedURI,
				documentURI: e.documentURI,
				effectiveDirective: e.effectiveDirective,
				disposition: e.disposition,
				statusCode: e.statusCode,
				sourceFile: e.sourceFile || undefined,
				lineNumber: e.lineNumber ?? undefined,
				columnNumber: e.columnNumber ?? undefined
			};

			if (process.env.NODE_ENV === 'development') {
				console.warn('[CSP]', payload);
			}

			// Fire-and-forget; does not throw.
			API.post<void>(CSP_LOG_ENDPOINT, payload).catch(() => {});
		};

		document.addEventListener('securitypolicyviolation', handler);

		return () => {
			document.removeEventListener('securitypolicyviolation', handler);
		};
	}, []);
};
